import React from 'react';
import PrivacyPolicy from '../components/PrivacyPolicy';

const PartnerPrivacyPolicy = () => {
  return <PrivacyPolicy appType="partner" />;
};

export default PartnerPrivacyPolicy;
